<template lang="html">
  <v-alert
    v-bind="$attrs"
  >
    <v-layout wrap>
      <v-flex
        v-if="$attrs.label"
        xs12
        class="title"
        v-html="$attrs.label"
      />
      <v-flex
        xs12
        v-html="_formatLineBreaks($attrs.description)"
      />
      <div
        v-if="$attrs.linkText && $attrs.link"
        class="mt-4"
      >
        <v-btn
          outlined
          :color="$attrs.linkButtonColor || $attrs.type"
          :to="$attrs.link"
        >
          {{ $attrs.linkText }}
        </v-btn>
      </div>
    </v-layout>
  </v-alert>
</template>

<script>
import helpers from '@/mixins/helpers'
import element from '@/mixins/element'

export default {
  mixins: [ helpers, element ],
  props: {
    value: String
  }
}
</script>

<style lang="css" scoped>

</style>
